module.exports = __webpack_public_path__ + "static/media/ShardMeetingRoom5.33a90a70.jpg";